<template>
  <el-dialog :title="editFormTitle" :visible.sync="visible" width="600px" center>
    <el-form :model="editForm">
      <el-form-item label="医院名称" :label-width="formLabelWidth">
        <el-input v-model="editForm.hospital_name" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils'
import { editHospital, insertHospital } from '../../../api'

export default {
  name: 'EditHospital',
  data() {
    return {
      id: null,
      editForm: {
        hospital_name: ''
      },
      formLabelWidth: '153px',
      visible: false
    }
  },
  computed: {
    editFormTitle() {
      return isEmpty(this.id) ? '编辑医院' : '添加医院'
    }
  },
  methods: {
    async handleOpen(val) {
      let defaultFrom = {
        hospital_name: ''
      }
      this.id = null
      if (!isEmpty(val)) {
        defaultFrom = val
        this.id = val.id
      }
      this.editForm = defaultFrom
      this.visible = true
    },
    handleSubmit() {
      const { id } = this
      const { hospital_name } = this.editForm
      let c = insertHospital

      if (isEmpty(hospital_name)) return this.$message({ message: '请输入医院名称', type: 'warning' })

      const params = {
        hospital_name,
        username: sessionStorage.getItem('username')
      }
      if (id) {
        params.id = id
        c = editHospital
      }
      c(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.visible = false
    },
  }
}
</script>

<style scoped>

</style>
